import { useContext } from "react";

import {
  AuthContext,
  AuthContextType,
} from "@/components/pages_logged_in/auth/AuthContext";

/**
 * Returns the current user and workspace.
 *
 * Note: This can only be used inside children of <Authenticate>,
 * otherwise it will throw an error.
 *
 * @returns The current user and workspace.
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthContextProvider");
  }
  return context;
}
